/*
 * The trout check that used to live here is gone. It read the species off the cage context and
 * compared `fishTypes.id`, which is not a stable key for a row created by a sequence, and it
 * was a second trout check beside `isTroutFishType`. Its only caller, the detail panel, uses
 * `useIsTrout()` instead, which reads the same `stock.fishType` the pen supplies (WB-2207).
 */

export type HealthMaturationScoreKey = 'score1' | 'score2' | 'score3';

export function getHealthScoreDescriptionKey(
    detailNamespace: string,
    scoreKey: HealthMaturationScoreKey,
    isRainbowTrout: boolean
): string {
    if (detailNamespace === 'maturation' && isRainbowTrout) {
        return `detail.maturation.rainbowTrout.${scoreKey}Description`;
    }

    return `detail.${detailNamespace}.${scoreKey}Description`;
}
